import WebComponent from 'fg-frontend/src/webComponents/WebComponent';

export default class Toggler extends WebComponent {
  didMount() {
    const {
      toggleClass,
      target,
      inputTarget,
    } = this.props;

    this.on('click', () => {
      const inputElement = document.querySelector(inputTarget);
      this.element.classList.toggle(toggleClass);
      const targetElement = document.querySelector(target);
      targetElement.classList.toggle(toggleClass);
      const openToggles = document.querySelectorAll(`.${toggleClass}`);

      if (inputElement) {
        inputElement.focus();
      }

      openToggles.forEach((toggle) => {
        if ((toggle != this.element) && (toggle != targetElement)) {
          toggle.classList.remove(toggleClass);
        }
      });
    });
  }
}



// WEBPACK FOOTER //
// ./fe/web-hasicovoOnline/src/js/components/Toggler.js